module.exports = __webpack_public_path__ + "static/media/rider_mark_collected.2554e4c0.svg";